var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("审批表单")]),_vm._v(" "),_c('approveTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }